// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    APP_NAME: "Tea InnTech",
    DEMO_AC: "64895d42711473576ce39a7b",
    TABLE_LENGTH: 10,
    API_URL: 'https://teainntech.in:9292/backend/api',
    SOCKET_URL: "https://teainntech.in:9393",
    BANNER_TEXT:'This site is under development,please login at www.teainntech.com for live sales',

    BASE_HREF: "/",
    GOOGLE_CAPTCHA: {
        /**
         * Gmail Account: pramit.ivan@gmail.com
         * ------------------------------------
         */
        SITE_KEY: "6LeDwoYkAAAAABJcUKgyilGP-epLDP1cva-plIB6",
        SECRET_KEY: "6LeDwoYkAAAAAB4wkY7x_VnukOw29GGGG_8PFOH6",
    },

    CONFIG: {
        SHEET_MIN_AUTOPRICE_VALUE: 2
    }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
